import { Component } from '@angular/core';

@Component({
  selector: 'app-sureroute-test-object',
  templateUrl: './sureroute-test-object.component.html',
  styleUrls: ['./sureroute-test-object.component.scss']
})
export class SurerouteTestObjectComponent {

}
